import { log } from './log';

/**
 * No idea what this actually does. 🤷🏻‍♂️
 */
export function beforeActiveInstanceBlur()
{
    log('info', 'lifecycle::beforeActiveInstanceBlur');
}
